// extracted by mini-css-extract-plugin
module.exports = {"seoOnly":"CompanyEntitySummary_seoOnly__jzAAf"};